---
nb:
  activerecord:
    models:
      comment:
        one: Kommentar
        other: Kommentarer
  comments:
    add_comment: Legg til en kommentar
    notify_replies: Varsle meg om nye svar
